import Config from '../../config';
import Collection from '../../collection';
import Form from '../form';
import PickObjects from '../pick.objects';

import { hashify } from '../../utils/arrays';
import { roleai, roleAI, roleCK, roleAICK } from '../../roles';
import { beforeEq, after } from '../../utils/date';
import { pst, get } from '../../http/api';
import { ask } from '../../utils/popups';





export default Form.extend( {

    initialize(options = {}) {
        Form.prototype.initialize.call( this, options );

        options.orgClusters = hashify( options.organizations, 
            org => [org.id, org.cluster_id] );
    },

    onBind(model) {
        this.listenTo( model, 'change:service_object_id', () =>
            attachServiceObject( 
                model.get( 'service_object_id' ),
                model.get( 'service_object_layer_id' ),
                model,
                this.options.serviceObjectMappings ) );

        let manuallyChanged = false;
        const orgsWithDefaultAssignees = this.organizations()
            .filter( org => org.default_assigned_organization_id );
        const defaultAssignees = hashify( orgsWithDefaultAssignees,
            org => [org.id, org.default_assigned_organization_id] );
        const contractWithAssignees = this.contracts()
            .filter( contract => contract.assigned_organization );
        const assigneesOfContracts = hashify( contractWithAssignees,
            contract => [contract.id, contract.assigned_organization.id] );

        this.listenTo( model, 'change:organization_id', 
            (m, orgId) => {
                if (manuallyChanged && model.get( 'assigned_organization_id' ))
                    return;

                if (model.get( 'assigned_organization_id' ) == defaultAssignees[orgId])
                    return;

                if (model.get( 'contract_id' ) && assigneesOfContracts[model.get( 'contract_id' )])
                    if (defaultAssignees[orgId] != assigneesOfContracts[model.get( 'contract_id' )])
                        return;

                model.set( {
                    assigned_organization_id: defaultAssignees[orgId],
                    assigned_user_id: null
                } );
                setTimeout( () => manuallyChanged = false, 0 );
            } );
        this.listenTo( model, 'change:assigned_organization_id',
            () => manuallyChanged = true );
    },

    serialize() {
        const contractsHash = hashify( this.contracts(), contract => [contract.id, contract] );
        const typesHash = hashify( this.types(), type => [type.id, type] );
        const capabilities = this.model ? this.model.capabilities_ : undefined;

        return { 

            capabilities,

            fieldsSorted: [...this.fields()].sort( (f1, f2) =>   
                !f1.cluster && f2.cluster ? -1
                    : f1.cluster && !f2.cluster ? 1
                        : f1.order - f2.order ),

            orgsFn: () =>
                filterAvailableOrgs.call( this,
                    this.model, 
                    this.organizations().filter( org => org.id == this.model.get( 'assigned_organization' ) ) )
                .filter( org => 
                    this.model.id &&
                    org.id == this.model.get( 'organization_id' ) ||

                    !this.model.get( 'sys_org_id' ) && !this.model.get( 'sys_clr_id' ) &&
                    roleAICK.includes( Config.role() ) ||

                    !this.model.get( 'sys_org_id' ) && !this.model.get( 'sys_clr_id' ) &&
                    Config.orgs().includes( +org.id ) ||
                    
                    this.model.get( 'sys_org_id' ) && org.id == this.model.get( 'sys_org_id' ) &&
                    roleAICK.includes( Config.role() ) ||

                    this.model.get( 'sys_org_id' ) && org.id == this.model.get( 'sys_org_id' ) &&
                    roleai.includes( Config.role() ) &&
                    this.model.get( 'contract_id' ) &&
                    contractsHash[this.model.get( 'contract_id' )].grant_task_creation &&
                    contractsHash[this.model.get( 'contract_id' )].groups.length &&
                    checkContractGroupsAgainstTypeAndObject( this.model,
                        contractsHash[this.model.get( 'contract_id' )],
                        typesHash[this.model.get( 'type_id' )] ) ||
                        
                    this.model.get( 'sys_clr_id' ) && org.cluster_id == this.model.get( 'sys_clr_id' ) &&
                    roleAICK.includes( Config.role() ) ||

                    this.model.get( 'sys_clr_id' ) &&
                    org.cluster_id == this.model.get( 'sys_clr_id' ) &&
                    roleai.includes( Config.role() ) &&
                    this.model.get( 'contract_id' ) &&
                    contractsHash[this.model.get( 'contract_id' )].grant_task_creation &&
                    contractsHash[this.model.get( 'contract_id' )].groups.length &&
                    checkContractGroupsAgainstTypeAndObject( this.model,
                        contractsHash[this.model.get( 'contract_id' )],
                        typesHash[this.model.get( 'type_id' )] ) ),

            assignedOrgsFn: () =>
                filterAvailableOrgs.call( this,
                    this.model, 
                    this.organizations().filter( org => org.id == this.model.get( 'organization_id' ) ) )
                .map( org => [org, contractsHash[this.model.get( 'contract_id' )]] )
                .filter( ([org, contract]) =>
                    !contract ||
                    !contract.assigned_organization ||
                    org.id == contract.assigned_organization.id )
                .map( ([org]) => org ), 
    
            contractsFn: () => 
                filterAvailableContracts.call( this, this.model ),

            typesFn: () => 
                filterAvailableTypes.call( this, this.model ),

            prioritiesFn: () => 
                filterAvailablePriorities.call( this, this.model ),

            statusesFn: () =>
                filterAvailableStatuses.call( this, this.model )
                    .sort( (a, b) => {
                        if (a.order != undefined && b.order != undefined)
                            return a.order - b.order;
                        else if (a.order != undefined)
                            return -1;
                        else if (b.order != undefined)
                            return 1;
                        else if (a.name < b.name)
                            return -1;
                        else if (a.name > b.name)
                            return 1;
                        else
                            return a.id - b.id;
                    } ),

            dataTableObjectsFn: (q, offset, limit, $el) => {
                const tableId = $el.closest( '[data-table-id]' )[0].dataset.tableId;
                const pageNumber = offset / limit | 0;
                const dropCount = offset - pageNumber * limit;
                const realLimit = limit + dropCount;

                return get( '/datatables/{id}/features/count?format=json&sysTitle=true&titleSearch={q}' ).mapsurfer()
                    .map( response => response.count )
                    .chain( () => get( '/datatables/{id}/features?limit={limit}&sysTitle=true&titleSearch={q}' ).mapsurfer() )
                    .map( (response, r, total) => {
                        const options = response.features
                            .filter( (item, index) => index >= dropCount )
                            .map( ({ sys_title, ...attrs }) => ({ 
                                id: attrs[response.pkField], 
                                title: sys_title,
                            }) );

                        return { options, total };
                    } )
                    .execute( { 
                        q,
                        limit: realLimit,
                        id: tableId, 
                    } );
            },

            rolesFn: () =>
                filterAvailableRoles.call( this ),

        };
    },

    bindingFilters: {

        cfTriplet(fieldId, typeId, organizationId) {
            return { fieldId, typeId, organizationId };
        }

    },

    bindingHandlers: {

        cfVisible: {

            set($el, { fieldId, typeId, organizationId }) {
                const find = fields => {
                    for (let f of fields) {
                        if (f.id == fieldId) 
                            return [f, false];

                        const [g] = find( f.subfields );
                        if (g) 
                            return [g, true];
                    }

                    return [];
                };

                const [field, isNested] = find( this.view.fields() );
                if (isNested)
                    return $el.css( 'display', 'block' );

                const [organization] = this.view.organizations()
                    .filter( organization => organization.id == organizationId );

                if (!field.cluster || organization && field.cluster.id == organization.cluster_id)
                    if (field.is_for_all == 't' || field.is_for_all == true)
                        return $el.css( 'display', 'block' );
                    else if (field.types.includes( +typeId ) || field.types.includes( '' + typeId ))
                        return $el.css( 'display', 'block' );

                $el.css( 'display', 'none' );
            }

        }

    },

    [Form.event( 'data-objects:pick' )](tableId, fieldId, translit, format, minCount, path, amountEditable) {

        const [prev, meta] = this.bindingFilters.prepareCf.get( this.model.get( 'fields' ),
            fieldId, translit, format, null, minCount, tableId, 't', amountEditable, 
            undefined,
            path );

        const view = PickObjects.of( {
            dataTableId: +tableId,
            multiple: true,
            amountEditable: amountEditable == 't'
        } );

        const selected = (prev || [])
            .map( ({ object_id, num }) => ({ object_id, num, layer_id: tableId  }) );

        return ask( view.bind( { selected, } ), 'datatables::object - choose',
            'actions::choose', 'actions::cancel',
            { large: true } )

            .then( () => {
                const values = view.model.get( 'selected' );
                this.model.set(
                    this.bindingFilters.prepareCf.set( [values, meta] ) );
            } );
    },

    [Form.event( 'composite:remove-instance' )](path, fieldId, translit, format, minCount, instanceIndex) {
        const [instances, meta] = this.bindingFilters.prepareCf.get( this.model.get( 'fields' ),
            fieldId, translit, format, null, minCount,
            undefined, undefined, undefined, 
            undefined,
            path );

        const newInstances = instances.filter( (_, index) => index != instanceIndex );
        this.model.set(
            this.bindingFilters.prepareCf.set( [newInstances, meta] ) );

        this.render();
    },

    [Form.event( 'composite:add-instance' )](path, fieldId, translit, format, minCount) {
        const [instances, meta] = this.bindingFilters.prepareCf.get( this.model.get( 'fields' ),
            fieldId, translit, format, null, minCount,
            undefined, undefined, undefined, 
            undefined,
            path );

        const newInstances = [...instances];
        for (let i = instances.length; i < meta.min_count; i++)
            newInstances.push( {} );
        newInstances.push( {} );

        this.model.set(
            this.bindingFilters.prepareCf.set( [newInstances, meta] ) );

        this.render();
    },

    clusters() {
        return arraify( this.options.clusters );
    },

    organizations() {
        return arraify( this.options.organizations );
    },

    contracts() {
        return arraify( this.options.contracts );
    },

    types() {
        return arraify( this.options.types );
    },

    priorities() {
        return arraify( this.options.priorities );
    },

    statuses() {
        return arraify( this.options.statuses );
    },

    fields() {
        return arraify( this.options.fields );
    },

    roles() {
        return arraify( this.options.roles );
    },

} );





function arraify(possiblyCollection) {
    return possiblyCollection instanceof Collection ? possiblyCollection.toJSON() : possiblyCollection;
}

function attachServiceObject(objectId, layerId, task, mappings) {
    const mapping = mappings.find( m => m.get( 'layer' ).id == layerId );
    if (!mapping)
        return Promise.reject();

    return pst( `/tasks/mapping/layer/${layerId}/object/${objectId}?apiVersion=2.0` )
        .cerebellum().blocking()
        .execute().then( ({ task: objectResponse, sys_org_id, sys_clr_id }) => {
            const { id, lon, lat, fields: responseFields, ...responseAttrs } = objectResponse;
            const json = task.toJSON();
            const { fields: _, ...taskAttrs } = json;

            const taskFields = json.fields ? { ...json.fields } : {};
            const fieldsChanged = Object.keys( responseFields )
                .filter( key => 
                    taskFields[key] === undefined || 
                    taskFields[key].value === undefined || 
                    taskFields[key].value === '' )
                .map( key => [key, responseFields[key]] )
                .map( ([key, valueObject]) => taskFields[key] = valueObject )
                .length > 0;

            const attrsChanged = Object.keys( responseAttrs )
                .filter( key => 
                    taskAttrs[key] === undefined || 
                    taskAttrs[key] === '' )
                .map( key => [key, responseAttrs[key]] )
                .reduce( (hash, [key, value]) => (hash[key] = value, hash), {} );

            const attrsToSet = {
                sys_org_id, sys_clr_id,
                service_object_id: objectId,
                service_object_layer_id: layerId,
                ...attrsChanged,
            };

            if (lon && lat)
                attrsToSet.location = { lon, lat };
            if (fieldsChanged) 
                attrsToSet.fields = taskFields;

            task.set( attrsToSet );
            if (sys_org_id)
                // separately from "main" attrsToSet
                task.set( 'organization_id', sys_org_id );
        } );
}

function allowContractChange(model, contracts) {
    const [oldContract] = contracts
        .filter( contract => contract.id === model.get( 'contract_id' ) );

    if (~roleAI.indexOf( Config.role() ))
        return true;

    if (~roleCK.indexOf( Config.role() ))
        return true;

    if (!~roleai.indexOf( Config.role() ))
        return false;

    if (oldContract && !oldContract.grant_task_creation )
        return false;

    if (oldContract)
        if (!~Config.orgs().indexOf( oldContract.assigned_organization.id ))
            return false;

    return true;
}

function checkTypeAgainstOrg(type, org) {
    return !type.cluster 
            && type.default_type === 't' ||
        !type.cluster 
            && type.default_type === 'f' 
            && (type.departments.includes( +org.id ) || type.departments.includes( '' + org.id )) ||
        type.cluster && org.cluster_id == type.cluster.id
            && type.default_type === 't' ||
        type.cluster && org.cluster_id == type.cluster.id
            && type.default_type === 'f' 
            && (type.departments.includes( +org.id ) || type.departments.includes( '' + org.id ));
}

function checkTypeAgainstRole(type) {
    return type.role_ids == null ||
        type.role_ids.includes( Config.role() ) ||
        type.role_ids.includes( +Config.role() );
}

function filterAvailableOrgs(model, [otherOrg]) {
    const pickedClusterId = model.get( 'cluster_id' );

    const [type] = this.types()
        .filter( type => type.id == model.get( 'type_id' ) );
    const [priority] = this.priorities()
        .filter( priority => priority.id == model.get( 'priority_id' ) );
    const [contract] = this.contracts()
        .filter( contract => contract.id == model.get( 'contract_id' ) );
    
    const clusterId = pickedClusterId ||
        type && type.cluster && type.cluster.id ||
        priority && priority.cluster && priority.cluster.id ||
        contract && contract.cluster.id ||
        otherOrg && otherOrg.cluster_id;

    return this.organizations()
        .filter( org => 
            !clusterId ||
            org.cluster_id == clusterId )
        .filter( org => 
            !type || 
            checkTypeAgainstOrg( type, org ) )
        .map( org => 
            ({ id: org.id, title: org.name, cluster_id: org.cluster_id }) );
}

function filterAvailableTypes(model) {
    const pickedClusterId = model.get( 'cluster_id' );

    const [priority] = this.priorities()
        .filter( priority => priority.id == model.get( 'priority_id' ) );
    const [org] = this.organizations()
        .filter( org => org.id == model.get( 'organization_id' ) );
    const [assOrg] = this.organizations()
        .filter( org => org.id == model.get( 'assigned_organization' ) );
    const [contract] = this.contracts()
        .filter( contract => contract.id == model.get( 'contract_id' ) );

    const clusterId = pickedClusterId ||
        priority && priority.cluster && priority.cluster.id ||
        contract && contract.cluster.id ||
        org && org.cluster_id ||
        assOrg && assOrg.cluster_id;

    return this.types()

        // check type against task organization
        .filter( type => 
            !org || checkTypeAgainstOrg( type, org ) ) 
        // check type against task assigned organization
        .filter( type => 
            !assOrg || checkTypeAgainstOrg( type, assOrg ) )

        .filter( type =>
            checkTypeAgainstRole( type ) )

        // check type against contract cluster
        .filter( type => 
            !clusterId ||
            !type.cluster || type.cluster.id == clusterId )

        // check type against contract groups
        .filter( type =>
            !contract || checkContractGroupsAgainstTypeAndObject( model, contract, type ) )

        .map( type => ({ id: type.id, title: type.name }) );
}

function filterAvailableContracts(model) {
    const pickedClusterId = model.get( 'cluster_id' );

    const [type] = this.types()
        .filter( type => type.id == model.get( 'type_id' ) );
    const [priority] = this.priorities()
        .filter( priority => priority.id == model.get( 'priority_id' ) );
    const [org] = this.organizations()
        .filter( org => org.id == model.get( 'organization_id' ) );
    const [assOrg] = this.organizations()
        .filter( org => org.id == model.get( 'assigned_organization' ) );
    
    const clusterId = pickedClusterId ||
        type && type.cluster && type.cluster.id ||
        priority && priority.cluster && priority.cluster.id ||
        org && org.cluster_id ||
        assOrg && assOrg.cluster_id;

    const commonPermission = allowContractChange( model, this.contracts() );
    return this.contracts()
        .filter( contract => 
            !contract.start_date ||
            beforeEq( contract.start_date, model.get( 'date' ) ) )
        .filter( contract => 
            !contract.finish_date ||
            after( contract.finish_date, model.get( 'date' ) ) )
        .filter( contract => !clusterId || contract.cluster.id == clusterId )
        .filter( contract => 
            !assOrg ||
            !contract.assigned_organization || 
            contract.assigned_organization.id == assOrg.id )

        // check contract groups against type and service objects
        .filter( contract => 
            checkContractGroupsAgainstTypeAndObject( model, contract, type ) )

        .filter( contract => {
            if (!commonPermission)
                return false;

            if (~roleAI.indexOf( Config.role() ))
                return true;
        
            if (~roleCK.indexOf( Config.role() ))
                return true;
        
            if (!contract.grant_task_creation)
                return false;
    
            if (!~Config.orgs().indexOf( contract.assigned_organization.id ))
                return false;

            return true;
        } );
}

function filterAvailablePriorities(model) {
    const pickedClusterId = model.get( 'cluster_id' );

    const [type] = this.types()
        .filter( type => type.id == model.get( 'type_id' ) );
    const [org] = this.organizations()
        .filter( org => org.id == model.get( 'organization_id' ) );
    const [assOrg] = this.organizations()
        .filter( org => org.id == model.get( 'assigned_organization' ) );
    const [contract] = this.contracts()
        .filter( contract => contract.id == model.get( 'contract_id' ) );

    const clusterId = pickedClusterId ||
        type && type.cluster && type.cluster.id ||
        contract && contract.cluster.id ||
        org && org.cluster_id ||
        assOrg && assOrg.cluster_id;

    return this.priorities()

        // check against contract cluster
        .filter( priority => 
            !clusterId ||
            !priority.cluster || priority.cluster.id == clusterId )

        .map( priority => ({ id: priority.id, title: priority.name }) );
}

function filterAvailableStatuses(model) {
    const pickedClusterId = model.get( 'cluster_id' );

    const [type] = this.types()
        .filter( type => type.id == model.get( 'type_id' ) );
    const [priority] = this.priorities()
        .filter( priority => priority.id == model.get( 'priority_id' ) );
    const [org] = this.organizations()
        .filter( org => org.id == model.get( 'organization_id' ) );
    const [assOrg] = this.organizations()
        .filter( org => org.id == model.get( 'assigned_organization' ) );
    const [contract] = this.contracts()
        .filter( contract => contract.id == model.get( 'contract_id' ) );

    const clusterId = pickedClusterId ||
        type && type.cluster && type.cluster.id ||
        priority && priority.cluster && priority.cluster.id ||
        contract && contract.cluster.id ||
        org && org.cluster_id ||
        assOrg && assOrg.cluster_id;

    const [cluster] = [
        ...this.clusters().filter( cluster => cluster.id == clusterId ),
        { id: clusterId } // temp fix if cluster is deleted
    ];



    return this.statuses()

        // check against cluster
        .filter( status => 
            !cluster.isolated && !status.cluster ||
            cluster.isolated && status.cluster && status.cluster.id == cluster.id )

        .filter( status => status.visible )

        .map( status => ({ 
            id: status.id, 
            title: status.name,
            order: status.order 
        }) );
}

function filterAvailableRoles() {
    const [type] = this.types()
        .filter( type => type.id == this.model.get( 'type_id' ) );

    return this.roles()

        .filter( role =>
            !type ||
            type.role_ids == null ||
            type.role_ids.includes( role.id ) || type.role_ids.includes( +role.id ) || type.role_ids.includes( '' + role.id ) );
}

function checkContractGroupsAgainstTypeAndObject(model, contract, type) {
    // no groups -> any type is okay
    return !contract.groups.length ||
        // otherwise: type is okay if there is any matching group
        0 < contract.groups
            // filter groups matched by service object id
            .filter( group =>
                // no objects -> group is okay
                !group.objects.length ||
                // no task object -> group is okay
                !model.get( 'service_object_id' ) ||
                // otherwise: group contains task object -> group is okay
                group.objects
                    .some( ({ object_id, layer_id }) =>
                        object_id == model.get( 'service_object_id' ) &&
                        layer_id == model.get( 'service_object_layer_id' ) ) )
            // filter group by matching type
            .filter( group => 
                !type ||
                // no types -> group is okay
                !group.types.length ||
                // otherwise: group must contain type
                group.types.some( t => t.id == type.id ) )
            .length;
}



// WEBPACK FOOTER //
// ./src/js/view/forms/task.js